import { createContext, ReactNode, FC, useContext } from 'react';

export type CheckoutType = 'modal' | 'page';

type CheckoutServerVarsContext = {
    isMobile: boolean;
    checkoutType: CheckoutType;
    closeCheckoutModal?: () => void;
};

export const CheckoutServerVarsContext = createContext<CheckoutServerVarsContext>({
    isMobile: false,
    checkoutType: 'page',
    closeCheckoutModal: () => {},
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
    checkoutType: CheckoutType;
    closeCheckoutModal?: CheckoutServerVarsContext['closeCheckoutModal'];
};

export const CheckoutServerVarsContextProvider: FC<Props> = ({
    children,
    isMobile,
    checkoutType,
    closeCheckoutModal,
}) => (
    <CheckoutServerVarsContext.Provider
        value={{
            isMobile,
            checkoutType,
            closeCheckoutModal,
        }}
    >
        {children}
    </CheckoutServerVarsContext.Provider>
);

export const useCheckoutServerVars = (): CheckoutServerVarsContext => {
    return useContext(CheckoutServerVarsContext);
};
